import React, { Component } from 'react';
import ModalBox from '../../components/ModalBox';

import './index.scss';

export default class AccessDeniedTermNotAcceptedModal extends Component {

  render() {

    const {
      onClose,
      modalActive,
    } = this.props

    return (

      <ModalBox
        modalActive={modalActive}
        modalLabel='Acesso não liberado'
        onChange={() => onClose()}
      >
        <div className="col s12 m4 offset-m4 access-denied-container">
          <div className="main-container">
            <i className="material-icons">block</i>
            <p className="first-paragraph">Aceite contratual</p>
            <p className="flow-text">Você ainda não aceitou o termo contratual. Acesse o portal para fazer o aceite e tente novamente.</p>
            <button className="blue-btn btn" onClick={onClose}>OK</button>
          </div>
        </div>
      </ModalBox>

    )

  }

}